import { api } from "@/lib/api";

export function getVisitorId() {
  let id = localStorage.getItem("jayatk_visitor_id");
  if (!id) {
    id = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("jayatk_visitor_id", id);
  }
  return id;
}

export function trackPageview(path = "/") {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  const device = window.innerWidth < 768 ? "mobile" : "desktop";
  api.post("/analytics/pageview", {
    visitor_id: getVisitorId(), path, tz, device,
    referrer: document.referrer || "",
  }).catch(() => {});
}
